import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { of, Observable } from 'rxjs';
import {
  distinctUntilChanged,
  switchMap,
  catchError,
  filter,
  map,
  tap
} from 'rxjs/operators';
import {
  UsageService,
  UsageMessage
} from '../../shared/services/usage.service';
import {
  LoadAccountSuccess,
  LoadAccountFailed,
  ProfileActionTypes,
  ProfileActionUnion
} from './actions';
import { AccountService } from '../../profile/services/account.service';
import { Account, PortfolioOverviewData } from '../../profile/models/profile';

@Injectable()
export class ProfileOverviewEffects {
  @Effect()
  public readonly logProfileOverviewAccount: Observable<
    string
  > = this.actions.pipe(
    ofType(ProfileActionTypes.SetActiveAccount),
    map(
      (action: ProfileActionUnion) =>
        action.payload &&
        action.payload.isVisible &&
        action.payload.activeAccount
    ),
    filter((activeAccount: string) => !!activeAccount),
    distinctUntilChanged(),
    tap((activeAccount: string) =>
      this.usageService.next({
        type: UsageMessage.VIEW_CREATED,
        message: ProfileActionTypes.SetActiveAccount,
        details: { activeAccount }
      })
    )
  );

  @Effect()
  public readonly loadAccount$: Observable<
    ProfileActionUnion
  > = this.actions.pipe(
    ofType(ProfileActionTypes.LoadRequested),
    switchMap((action: Action) =>
      this.accountService.getAccount().pipe(
        map(
          (portfolioData: PortfolioOverviewData) =>
            new LoadAccountSuccess(portfolioData as Account)
        ),
        catchError((error: Error | HttpResponse<PortfolioOverviewData>) =>
          of(
            new LoadAccountFailed(
              (error as Error).message ||
                (error as HttpResponse<PortfolioOverviewData>).statusText
            )
          )
        )
      )
    )
  );

  constructor(
    private actions: Actions,
    private accountService: AccountService,
    public usageService: UsageService
  ) {}
}
